import React, { useContext, useEffect, useState } from "react";
import { Spin } from "antd";
import axios from "axios";
import { Card } from "react-bootstrap";
import PsContext from "../../context";
import { ParseFloat, groupByMultiple, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { _ListHourPerDay, _ListHourPerDayMob } from "../../models/utilities";
import { Toast } from "antd-mobile";

const AttendancePercentage = (props) => {
  const context = useContext(PsContext);

  const [loader, setLoader] = useState(false);
  const today = momentDate(new Date(), "YYYY-MM-DD");

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [dayOrders, setDayOrders] = useState([]);
  const [attType, setAttType] = useState("");
  const [hourCount, setHourCount] = useState(
    /*  context.settingValue(
      "hour_for_attendance_per_day",
      context.user.college_uuid
    ) */ null
  );

  const [showAtt, setShowAtt] = useState(false);
  const [myData, setMyData] = useState([]);
  const [attHourPerDay, setAttHourPerDay] = useState(null);

  useEffect(() => {
    setShowAtt(props.show);
    loadAttHour();
    loadData();
  }, [props.show]);

  const loadAttHour = () => {
    setLoader(true);
    let s = {
      course_uuid: context.user.course_uuid,
      batch: context.user.batch,
      college_uuid: context.user.college_uuid,
    };
    _ListHourPerDayMob(s).then((res) => {
      if (res.status == "1") {
        setHourCount(res.data[0].att_hour_per_day);
      } else {
        setHourCount(
          context.settingValue(
            "hour_for_attendance_per_day",
            context.user.college_uuid
          )
        );
        if (
          !context.settingValue(
            "hour_for_attendance_per_day",
            context.user.college_uuid
          )
        ) {
          Toast.show({
            content: "Attendance hour not assigned for this course and batch.",
          });
        }
      }
      setLoader(false);
    });
  };

  const loadData = () => {
    setLoader(true);
    setDataList([]);
    setDayOrders([]);
    axios.post(ServiceUrl.STUDENTS.MY_ATTENDANCE_PERCENTAGE).then((res) => {
      if (res.data.status == "1") {
        if (res.data.hour_count) setHourCount(res.data.hour_count);
        setAttType(res.data.type);
        setDayOrders(res.data.day_order);
        if (res.data.type == "day_by_half") {
          let s = groupByMultiple(res.data.data, function (obj) {
            return [obj.attendance_date];
          });
          let x = [];
          s.map((item) => x.push(item[0]));
          setDataView(x);
          setDataList(res.data.data);
          setMyData(res.data.student);
        } else {
          setDataList(res.data.data);
          setDataView(res.data.data);
          setMyData(res.data.student);
        }
      }
      setLoader(false);
    });
  };

  const daysInMonth = (month) => {
    let x = dayOrders.filter(
      (item) =>
        momentDate(item.day_order_date, "YYYY-MM") == month &&
        momentDate(item.day_order_date, "YYYY-MM-DD") >=
          momentDate(myData.admissiondate, "YYYY-MM-DD")
    );
    return x.length;
  };

  const getDaysPresentInMonth = (attDate) => {
    if (attType == "day_by_half") {
      let x = dataList.filter((obj) => obj.attendance_date == attDate);
      let total = 0;
      x.map((item) => (total = parseFloat(total) + parseFloat(item.days)));
      return ParseFloat(total, 2);
    } else {
      let x = dataList.find((obj) => obj.attendance_date == attDate);
      if (x) return ParseFloat(x.days, 2);
      else return "-";
    }
  };

  const getTotalDaysPresent = () => {
    let total = 0;
    try {
      if (attType == "day_by_half") {
        let x = dataList;
        x.map((item) => (total = parseFloat(total) + parseFloat(item.days)));
      } else {
        let x = dataList;
        x.map(
          (item) => (total = parseFloat(total) + parseFloat(item.present_hours))
        );

        total =
          Math.floor(parseFloat(total) / parseFloat(hourCount)) +
          "." +
          (parseFloat(total) % parseFloat(hourCount));
      }
    } catch (er) {
      console.log(er);
    }
    return ParseFloat(total, 2);
  };

  const getTotalPercentage = () => {
    try {
      let rawDaysPresent = getTotalDaysPresent();
      let integerPart = Math.floor(rawDaysPresent);
      let decimalPart = rawDaysPresent - integerPart;
      let adjustedDecimal = (decimalPart / parseInt(hourCount)) * 10;
      let daysPresent = integerPart + adjustedDecimal;

      let totalDays = dayOrders.length;
      if (myData.admissiondate && myData.admissiondate.length > 4) {
        let filteredDays = dayOrders.filter(
          (item) =>
            momentDate(item.day_order_date, "YYYY-MM-DD") >=
            momentDate(myData.admissiondate, "YYYY-MM-DD")
        );
        totalDays = filteredDays.length;
      }

      let percentage = parseFloat(daysPresent) / parseFloat(totalDays);

      let roundedPercentage = parseFloat((percentage * 100).toFixed(2));
      return isNaN(roundedPercentage) || !isFinite(roundedPercentage)
        ? "0"
        : roundedPercentage.toString();
    } catch (error) {
      return "0";
    }
  };

  useEffect(() => {
    if (showAtt && dataList.length < 1) loadData();
  }, [showAtt]);

  const getTotalDayOrderDays = () => {
    let x =
      dayOrders &&
      dayOrders.length > 0 &&
      dayOrders.filter(
        (item) =>
          momentDate(item.day_order_date, "YYYY-MM-DD") >=
          momentDate(myData.admissiondate, "YYYY-MM-DD")
      );
    return (x && x.length) || 0;
  };

  useEffect(() => {
    if (dataList.length > 0 && props.getTotalPercentage) {
      const percentage = getTotalPercentage();
      props.getTotalPercentage(percentage);
    }
  }, [dataList, dayOrders, attType, hourCount, myData]);

  return (
    <div className="mb-3">
      {showAtt && (
        <Spin spinning={loader}>
          <TableContainer component={Paper}>
            <Table aria-label="attendance table">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Month</TableCell>
                  <TableCell align="center">Total Days</TableCell>
                  <TableCell align="center">Present Days</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {dataView.map((item) => (
                  <TableRow
                    key={item.attendance_date}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      backgroundColor: "#f7f7f7", // Add your custom color
                    }}
                  >
                    <TableCell align="left">
                      {momentDate(item.attendance_date, "YYYY, MMMM")}
                    </TableCell>
                    <TableCell align="center">
                      {daysInMonth(item.attendance_date)}
                    </TableCell>
                    <TableCell align="center">
                      {getDaysPresentInMonth(item.attendance_date)}
                    </TableCell>
                  </TableRow>
                ))}
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor: "#e0f7fa", // Light color for "Total"
                  }}
                >
                  <TableCell align="left">Total</TableCell>
                  <TableCell align="center">{getTotalDayOrderDays()}</TableCell>
                  <TableCell align="center">{getTotalDaysPresent()}</TableCell>
                </TableRow>
                <TableRow
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    backgroundColor: "#ffe0b2", // For percentage row
                  }}
                >
                  <TableCell align="left"></TableCell>
                  <TableCell align="center">%</TableCell>
                  <TableCell align="center">{getTotalPercentage()}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Spin>
      )}
    </div>
  );
};

export default AttendancePercentage;
